module.exports = __webpack_public_path__ + "static/media/sociana_demo.96f81451.mp4";